import { roundAmount } from 'src/utils/roundAmount'

type Props = Readonly<{
  marbleUuid: string
  multipliers?: Record<string, number>
  boostPercentage?: number
}>

export function MarblePaneMultiplier({ marbleUuid, multipliers, boostPercentage }: Props) {
  if (!multipliers || !multipliers[marbleUuid]) return null

  const baseMultiplier = multipliers[marbleUuid]
  const boostedMultiplier = boostPercentage
    ? baseMultiplier * (1 + boostPercentage / 100)
    : baseMultiplier

  return <span className="marble-odds-value">{roundAmount(boostedMultiplier)}x</span>
}
